const config = {
    environment: process.env.ENVIRONMENT,
    redirectUrl: process.env.VUE_APP_REDIRECT_URL,
    baseApiUrl: process.env.VUE_APP_API_BASE_URL,
    // baseApiUrl: `https://${process.env.ENVIRONMENT}.api.springbig.technology/brands/v1`,
    rollbar: {
        enabled: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN !== undefined,
        accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN
    }
};

if(config.environment === 'local') {
    config.baseApiUrl = `${process.env.VUE_APP_API_BASE_URL}/brands/v1`;
}

export default config;
